<template>
  <div>
    <!-- <img
      v-show="currentCategory == 'ด้านสัมพันธภาพระหว่างบุคคล' && !finish"
      src="@/assets/relationship.png"
      alt
      class="w-128 mb-8 md:mx-16 absolute right-0 bottom-0 hidden md:block"
    />
    <img
      v-show="currentCategory == 'ด้านการเคลื่อนไหวร่างกาย' && !finish"
      src="@/assets/dog-walking.png"
      alt
      class="w-96 mb-8 md:mx-16 absolute right-0 bottom-0 hidden md:block"
    />
    <img
      v-show="currentCategory == 'ด้านการพัฒนาจิตวิญญาณ' && !finish"
      src="@/assets/thinking.png"
      alt
      class="w-96 mb-8 md:mx-16 absolute right-0 bottom-0 hidden md:block"
    />
    <img
      v-show="currentCategory == 'ด้านความรับผิดชอบต่อสุขภาพ' && !finish"
      src="@/assets/running.png"
      alt
      class="w-64 mb-8 md:mx-16 absolute right-0 bottom-0 hidden md:block"
    />
    <img
      v-show="currentCategory == 'ด้านการจัดการกับความเครียด' && !finish"
      src="@/assets/stress.png"
      alt
      class="w-64 mb-8 md:mx-16 absolute right-0 bottom-0 hidden md:block"
    />
    <img
      v-show="currentCategory == 'ด้านโภชนาการ' && !finish"
      src="@/assets/eating.png"
      alt
      class="w-64 mb-8 md:mx-16 absolute right-0 bottom-0 hidden md:block"
    /> -->

    <div>
      <yan-progress class="absolute bottom-0" :total="100" :done="progress" />
      <vue-tiny-slider
        ref="assessmentSliderHplp"
        axis="vertical"
        class="mt-2 md:mt-8"
        :controls="false"
        :loop="false"
        :rewind="false"
        :touch="false"
        :mouseDrag="false"
      >
        <div
          v-for="(assessment, assessmentIndex) in categorizedAssessment"
          :key="`${assessment.index}${assessmentIndex}`"
          :loop="false"
          class="px-8"
        >
          <p
            class="text-gray-700 text-xl text-center mb-2 w-full w-96"
          >{{ assessmentIndex + 1 }}. {{ assessment.question }}</p>
          <p class="text-center mb-8 text-primary">{{ assessment.category }}</p>

          <div class="flex flex-col items-center px-8">
            <button
              v-for="(choice, index) in choices"
              :key="`${choice}${index}`"
              @click="next(assessment, choice, assessmentIndex)"
              class="answer-button w-full md:w-96 py-4 text-gray-700 text-base"
            >{{ choice.title }}</button>

            <button
              @click="back"
              class="w-full md:w-96 py-1 mb-2 text-primary outline-none"
            >ย้อนกลับ</button>
          </div>
        </div>
      </vue-tiny-slider>

      <div
        class="hidden md:flex flex-col md:flex-row justify-center items-center md:w-256 md:mt-12 mx-auto"
      >
        <img src="@/assets/cmu-logo.png" alt class="w-16 h-16 mb-8 md:mx-16" />

        <img src="@/assets/healthy-university-logo.jpg" class="w-24 h-24 mb-12 md:mx-16" />

        <img src="@/assets/stay-home-logo.jpg" class="w-24 h-24 mb-12 md:mx-16" />
      </div>
    </div>
  </div>
</template>

<script>
import VueTinySlider from "vue-tiny-slider";
import { categories, assessments, choices } from "../data/assessment-hplp";
import { notification } from "ant-design-vue";
import { std } from "mathjs";
import axios from "axios";

export default {
  components: {
    VueTinySlider
  },
  mounted() {
    window.onbeforeunload = function() {
      return "คุณต้องการออกจากแบบสอบถามหรือไม่";
    };
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  data() {
    return {
      categories,
      assessments,
      choices,
      answers: [],
      categoriesWithAnswers: [],
      finalWithAnswer: {
        evaluatedResult: "",
        totalAverage: 0,
        sd: 0
      },
      progress: 0,
      finish: false,
      currentCategory: "ด้านสัมพันธภาพระหว่างบุคคล"
    };
  },
  methods: {
    std,
    back() {
      this.$refs.assessmentSliderHplp.slider.goTo("prev");
    },
    next(assessment, choice, index) {
      this.answers.push({ assessment, choice });

      this.$refs.assessmentSliderHplp.slider.goTo("next");

      this.evaluate();

      this.currentCategory = assessment.category;

      this.progress += 100 / this.categorizedAssessment.length;

      if (this.isFinish(index + 1)) {
        this.submit();
      }
    },
    evaluate() {
      let withAnswered = this.categories.map(category => {
        const answers = this.answers.filter(
          answer =>
            category.questions.includes(answer.assessment.index) &&
            answer.assessment.category == category.title_th
        );

        category.answers = answers;

        const totalScore = answers.reduce(
          (total, answer) => total + answer.choice.score,
          0
        );
        category.totalScore = totalScore;

        const average = totalScore / category.questions.length;
        category.average = average;

        let evaluatedResult = "";
        if (average >= 3) {
          evaluatedResult = "ดีมาก";
        } else if (average >= 2) {
          evaluatedResult = "ดี";
        } else if (average >= 1) {
          evaluatedResult = "พอใช้";
        } else {
          evaluatedResult = "ต้องปรับปรุง";
        }

        category.evaluatedResult = evaluatedResult;

        return category;
      });

      const totalAverage =
        withAnswered.reduce(
          (total, category) => total + category.totalScore,
          0
        ) / this.categorizedAssessment.length;

      this.finalWithAnswer.totalAverage = totalAverage;

      if (totalAverage >= 3) {
        this.finalWithAnswer.evaluatedResult = "ดีมาก";
      } else if (totalAverage >= 2) {
        this.finalWithAnswer.evaluatedResult = "ดี";
      } else if (totalAverage >= 1) {
        this.finalWithAnswer.evaluatedResult = "พอใช้";
      } else {
        this.finalWithAnswer.evaluatedResult = "ต้องปรับปรุง";
      }

      this.categoriesWithAnswers = withAnswered;
    },
    isFinish(index) {
      return index == this.categorizedAssessment.length;
    },
    reset() {
      location.reload();
    },
    async submit() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer
      });

      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/me/hplp-assessment`,
          headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
          data: {
            finalResult: this.finalWithAnswer.evaluatedResult,
            rawFinalResult: JSON.stringify(this.finalWithAnswer),
            rawAnswers: JSON.stringify(this.categorizedAssessment),
            rawCategoriesWithAnswers: JSON.stringify(
              this.categoriesWithAnswers
            ),
            average: this.average,
            standardDeviation: this.standardDeviation
          }
        });

        loader.hide();

        this.$notify({
          type: "success",
          group: "foo",
          title: "บันทึกผลการคัดกรองแล้ว",
          text: "ข้อมูลของท่านจะถูกบันทึกในฐานข้อมูลและสามารถเข้าดูย้อนหลังได้"
        });

        const { id } = response.data;

        this.$router.push(`/assessment-hplp/${id}`);
      } catch (error) {
        console.log(error);

        loader.hide();

        this.$notify({
          type: "error",
          group: "foo",
          title: "บันทึกไม่สำเร็จ",
          text: "ลองใหม่อีกครั้ง"
        });
      }
    }
  },
  computed: {
    categorizedAssessment() {
      const ass = this.categories.map(category => {
        category.assessments = category.questions.map(question => {
          const assessment = {
            ...this.assessments.find(assessment => question == assessment.index)
          };

          assessment.category = category.title_th;

          return assessment;
        });

        return category;
      });

      let assessments = [];
      for (let index = 0; index < ass.length; index++) {
        assessments.push(ass[index].assessments);
      }

      return assessments.flat();
    },
    categoryTotalScores() {
      return this.categoriesWithAnswers.map(category => category.totalScore);
    },
    average() {
      return this.finalWithAnswer.totalAverage.toFixed(2);
    },
    standardDeviation() {
      return std(this.answers.map(answer => answer.choice.score)).toFixed(2);
    }
  }
};
</script>

<style lang="css">

@import "../assets/tiny-slider.css";

.is-active {
  color: red;
}
</style>
